// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Product_mainContainer__3vrV3","container":"Product_container__3ck1N"};